import { useQuery } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useCoachesState = () => {
	return useQuery({
		queryKey: ["coaches-state"],
		queryFn: () => EndpointsService.dataRetriever.getCoachesState(),
	});
};
